// @flow
import * as React from 'react';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';

import {
  Api,
  createApiData,
  standartRequests,
  type OccurType,
  type ErrorByIdType,
  type RequestFuncType,
  type StandartRequestFuncType,
} from 'app/common/context/Api';


export const Purchases = createApiData();

const PENDING: 0 = 0;
const SPENT: 1 = 1;
const DELETED: -1 = -1;

export const statuses = {
  PENDING,
  SPENT,
  DELETED,
};

const makeRequestsData = (id, from, to, status, autoRequest, schoolId, t) => ((id && from && to) ? {
  purchases: {
    path: 'cafeteria/customer/purchases',
    type: 'get',
    rest: {
      params: {
        customer_id: id,
        from_date: from,
        to_date: to,
        status,
        school_id: schoolId,
        for_camp: !!schoolId,
      },
    },
    cbErrorTextCreate: (/* error */) => (from === to
      ? t('purchases_fetch_error', { from: moment(from).format('D MMMM YYYY') })
      : t('purchases_fetch_error_period', { from: moment(from).format('D MMMM YYYY'), to: moment(to).format('D MMMM YYYY') })
    ),
    autoRequest,
  },
} : {});

export type PurchaseItem = {
  guid: string,
  id: number,
  title: string,
  type: 'item' | 'complex' | 1 | 0,
  items?: Array<string>,
  portion: null,
  subsidy: null,
  cost: number,
  n: number,
  total: number,
  free_for_sale: boolean,
}

export type Purchase = {
  guid: string,
  datetime: string, // 2017-04-01T11:22:09+03:00
  status: $Values<typeof statuses>,
  number: number,
  individual: boolean,
  conducted_by: string,
  created_by: string,
  created_with: 'terminal' | 'mobile' | 'computer',
  total: number,
  items: Array<PurchaseItem>,
  sale_point_id: number,
  building_id: number,
}

export type State = {
  content: {
    purchases: {
      [string]: Purchase,
    }
  },
  loading: boolean,
  occur: OccurType,
  request: {
    purchases: RequestFuncType,
    [$Values < typeof standartRequests >]: StandartRequestFuncType,
  },
  error?: { [string]: mixed },
  errorById?: ErrorByIdType,
}

type Props = {
  personId: number,
  from: string,
  to: string,
  status?: number,
  autoRequest?: boolean,
  children: React.Node | (value: State) => React.Node,
}

const initialContent = {
  purchases: {},
};

export const PurchasesApi = ({ children, personId, from, to, status, schoolId, autoRequest }: Props) => {
  const { t } = useTranslation('cafeteria');

  const descriptions = React.useMemo(
    () => makeRequestsData(personId, from, to, status, !!autoRequest, schoolId, t),
    [personId, from, to, status, autoRequest, schoolId, t],
  );

  return (
    <Api
      // consoleLogName="PurchasesApi"
      apiData={Purchases}
      descriptions={descriptions}
      initialContent={initialContent}
      addStandartRequests
    >
      {children}
    </Api>
  );
};
